import { Component, ElementRef, Inject, InjectionToken, OnInit, ViewChild } from '@angular/core';
import Ajv from "ajv"
import { APP_Constants } from 'src/app/app.constant';
export const AJV_INSTANCE = new InjectionToken<Ajv>('The AJV Class Instance');
import { AppService } from '../../app.service';
import {SchemaVal} from '../../../models/schema.model';




@Component({
  selector: 'app-schema-validation',
  templateUrl: './schema-validation.component.html',
  styleUrls: ['./schema-validation.component.scss'],
  standalone: false
})
export class SchemaValidationComponent implements OnInit {
  msg: any;
  uploadOrderTemplate: any;
  commonSubject: any;
  currentTemp : SchemaVal={
    tempalte_id:'',
    action:'',
    // ui_template:{v},
  
   
  };
  schema: any;
  flag: boolean = true;
  modalService: any;
  isLoading: boolean = false;
  mode: any;
  color: any;
  formData: any;
  noError: boolean = false;
  customerCode: string;
  message: any;


  constructor(@Inject(AJV_INSTANCE) private readonly ajv: Ajv, private appService: AppService,) {
  }

  ngOnInit(): void {
   
    this.appService.makeHttpGetRequest(APP_Constants.VALIDATE_SCHEMA +
      localStorage.getItem('userName') + '&action=VALIDATE_SCHEMA').subscribe(
        data => {
          this.schema=data;
        }),

    this.appService.makeHttpGetRequest(APP_Constants.VALIDATE_SCHEMA +
      localStorage.getItem('userName') + '&action=UPLOAD_UI_TEMPLATE_FOR_SCHEMA_VALIDATION').subscribe(
        (res: any) => {
          this.uploadOrderTemplate=res.data.template;
        }),

    this.customerCode = localStorage.getItem("customerCode")
    console.log(this.customerCode)
  }


  submitUploadOrderDetails(data) {
    this.formData = data.postData.param;
    this.flag = false;
    this.noError = false;
    let fileData = this.appService.getUploadFileData();
    let base64FileData1
    let base64FileData
    let finalTemp
    this.appService.getBase64(fileData).then((base64Data) => {
      if (base64Data) {
        base64FileData1 = base64Data;
        base64FileData = base64FileData1.split(',');
        let encoded: string = atob(base64FileData[1]);
        finalTemp = JSON.parse(encoded)
      }

      const ajv = new Ajv({ allErrors: true, strict: false })
      ajv.addKeyword('ref')
      const validate = ajv.compile(this.schema.data.template)
      const valid1 = validate(finalTemp)
      if (!valid1) {
        this.msg = JSON.stringify(validate.errors);
      } else {
        this.noError = true;
      }

    })
  }

  ngAfterViewInit() {
    this.commonSubject = this.appService._commonComponentSubject.subscribe(res => {
      if (res) {
        if (res.name === this.uploadOrderTemplate.name && res.action === 'SUBMIT' && res.configData) {
          this.noError = false;
          this.submitUploadOrderDetails(res);
        }
      }
    })
  }
}

